import type { SelectionMarkerPluginOptions } from '@atlaskit/editor-plugin-selection-marker';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options: {
		__livePage: boolean;
	};
}

export function selectionMarkerPluginOptions({
	options,
}: Props): SelectionMarkerPluginOptions | undefined {
	// SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
	return fg('platform_editor_no_cursor_on_live_doc_init')
		? { hideCursorOnInit: options.__livePage }
		: undefined;
	// END SECTION
}
